var OptionsSelects = {
  trackTypeOptions: [
    { value: 0, label: "Thoroughbred" },
    { value: 1, label: "Harness" },
    { value: 2, label: "Greyhounds" },
  ],

  closeMethodOptions: [
    { value: 0, label: "Post Time" },
    { value: 1, label: "Feed" },
    { value: 2, label: "3 MTP" },
    { value: 3, label: "2 MTP" },
    { value: 4, label: "1 MTP" },
    { value: 5, label: "0 MTP" },
  ],

  scoringRuleOptions: [
    { value: 0, label: "AllStatePicks" },
    { value: 1, label: "ExceptPick3" },
    { value: 2, label: "FairGrounds" },
  ],
};

export default OptionsSelects;
